module.exports = __webpack_public_path__ + "img/35_32.26f0f199.png";